import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";

export function InvoiceStepPushPC(props) {

    const invoice = useSelector(state => state.invoices.invoice);

    return (
        <>
                <div className="content1 iblock gap-above-m" >{`${invoice.AR.first_name} ${invoice.AR.last_name}`}</div>
                <div className="content2 light-black multiline" style={{whiteSpace: "pre-wrap"}}>
                    may push the invoice through the {invoice.stage == "REV" ? "Review and Payment stages" : "Payment Stage"} and mark it as closed if payment has already been made in full.
                </div>
                <button className="btn sec mini gap-above-s" onClick={() => props.setPushPCModalOpen(true)}>&nbsp; Skip to Close</button>

        </>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(InvoiceStepPushPC);